exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-pages-index-tsx": () => import("./../../../src/templates/pages/index.tsx" /* webpackChunkName: "component---src-templates-pages-index-tsx" */)
}

